import { Badge } from 'maeng-daisyui'
import Message from 'maeng-utils/locale'
import React from 'react'

const TechSkill = () => {
  const techSkills = [
    'React',
    'Vue',
    'Next',
    'Nuxt',
    'JavaScript',
    'TypeScript',
    'HTML/CSS(SASS)',
    'StyledComponent',
    'Tailwindcss',
  ]
  return (
    <section className="mb-14">
      <Message
        i18nKey="portfolio.techSkill.title"
        className="text-2xl font-semibold mb-6"
        component="h4"
      />
      <p className="text-lg leading-8 mb-2">
        {techSkills.map((skill) => (
          <Badge className="mr-1 font-medium" key={skill} color="ghost">
            {skill}
          </Badge>
        ))}
        <Message i18nKey="portfolio.techSkill.description" component="span" />
      </p>
      <ul>
        <Message
          i18nKey="portfolio.techSkill.details"
          className="text-lg leading-8 check-list"
          component="li"
          values={{
            b: <b className="font-semibold highlight-[#ffaf1933]" />,
          }}
        />
      </ul>
    </section>
  )
}

export default TechSkill
